import React from "react";
import clsx from "clsx";
import { Box } from '@curves/ui-base';
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { AnalysisResultBox } from "../Common";

const MeasurementResultClickableCard = ({ className, name, value = 0, unit, icon, onClick, notifyType = 1, tip, desc }) => {
	return (
		<Box className={clsx("measurement-result-clickable-card", "measurement-clickable-card", className)} onClick={onClick}>
			<Box className="measurement-clickable-card__icon-right">
				<ChevronRightIcon />
			</Box>
			<Box className="measurement-clickable-card__header">
				{icon != null && (
					<Box className="measurement-clickable-card__icon" aria-hidden>
						{typeof icon === "function" ? React.createElement(icon, {}) : icon}
					</Box>
				)}
				<Box className="measurement-clickable-card__title">{name}</Box>
			</Box>
			<Box className="measurement-clickable-card__body">
				<Box className="measurement-clickable-card__value measurement-clickable-card__value--normal">
					{value}
					{unit && <Box className="measurement-clickable-card__value-unit">{unit}</Box>}
				</Box>
			</Box>
			<AnalysisResultBox Tip={tip} Desc={desc} notifyType={notifyType} />
		</Box>
	);
};

export default MeasurementResultClickableCard;
